var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "viewBox": "0 0 200 200",
      "width": "200",
      "height": "200",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,0.000000) scale(0.393701) translate(-0.000000,-0.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "svg-1",
      "transform": "matrix(0.2504510283470154, 0, 0, 0.2504510283470154, 394.6092224121094, 132.95411682128903)"
    }
  }, [_c('circle', {
    staticStyle: {
      "stroke-width": "0.248",
      "fill": "rgb(33, 150, 243)"
    },
    attrs: {
      "cx": "-563.18",
      "cy": "482.983",
      "r": "1013.17"
    }
  }), _c('path', {
    staticStyle: {
      "stroke-width": "0.248",
      "fill": "rgb(29, 127, 206)"
    },
    attrs: {
      "d": "M -559.58 1494.55 C -60.476 1490.71 353.513 1127.58 436.631 650.776 L -298.24 -84.693 L -349.39 -85.612 L -540.4 -76.701 L -443.69 20.362 L -796.95 260.764 L -1049.5 456.649 L -615.92 890.259 L -1024.3 1029.6 L -559.58 1494.55 Z"
    }
  }), _c('polygon', {
    staticStyle: {
      "fill": "rgb(255, 198, 27)",
      "stroke-width": "0.248"
    },
    attrs: {
      "points": "-433.7 241.703 -433.7 438.667 -729.01 438.667 -729.01 635.632 -1024.3 635.632 -1024.3 1029.6 -729.01 1029.6 -433.7 1029.6 -138.4 1029.6 -138.4 241.703"
    }
  }), _c('rect', {
    staticStyle: {
      "stroke-width": "0.248",
      "fill": "rgb(50, 75, 94)"
    },
    attrs: {
      "x": "-1024.3",
      "y": "635.672",
      "width": "295.447",
      "height": "393.905"
    }
  }), _c('rect', {
    staticStyle: {
      "stroke-width": "0.248",
      "fill": "rgb(42, 59, 80)"
    },
    attrs: {
      "x": "-875.27",
      "y": "635.672",
      "width": "146.574",
      "height": "393.905"
    }
  }), _c('rect', {
    staticStyle: {
      "stroke-width": "0.248",
      "fill": "rgb(50, 75, 94)"
    },
    attrs: {
      "x": "-729.01",
      "y": "438.667",
      "width": "295.447",
      "height": "590.885"
    }
  }), _c('rect', {
    staticStyle: {
      "stroke-width": "0.248",
      "fill": "rgb(42, 59, 80)"
    },
    attrs: {
      "x": "-576.76",
      "y": "438.667",
      "width": "143.138",
      "height": "590.885"
    }
  }), _c('rect', {
    staticStyle: {
      "stroke-width": "0.248",
      "fill": "rgb(50, 75, 94)"
    },
    attrs: {
      "x": "-433.7",
      "y": "241.663",
      "width": "295.447",
      "height": "787.886"
    }
  }), _c('rect', {
    staticStyle: {
      "stroke-width": "0.248",
      "fill": "rgb(42, 59, 80)"
    },
    attrs: {
      "x": "-283.06",
      "y": "241.663",
      "width": "144.832",
      "height": "787.886"
    }
  }), _c('path', {
    staticStyle: {
      "stroke-width": "0.248",
      "fill": "rgb(255, 227, 87)"
    },
    attrs: {
      "d": "M -316.22 -94.564 L -510.83 -125.33 C -527.61 -128.05 -543.6 -116.54 -545.99 -99.64 C -548.79 -82.775 -537.2 -66.951 -520.42 -64.274 L -400.14 -45.252 L -1042.3 413.492 C -1055.9 423.442 -1059.1 442.743 -1049.5 456.649 C -1043.1 465.081 -1033.9 469.596 -1023.9 469.596 C -1017.9 469.596 -1011.9 467.718 -1006.3 463.802 L -363.38 4.138 L -382.56 125.698 C -384.95 142.561 -373.76 158.425 -356.98 161.103 C -354.98 161.342 -353.38 161.462 -351.79 161.462 C -337 161.462 -323.81 150.593 -321.42 135.368 L -290.65 -59.199 C -287.85 -76.022 -299.44 -91.886 -316.22 -94.564 Z"
    }
  }), _c('path', {
    staticStyle: {
      "stroke-width": "0.248",
      "fill": "rgb(253, 211, 78)"
    },
    attrs: {
      "d": "M -1050.3 455.171 C -1049.9 455.65 -1049.5 456.17 -1049.5 456.649 C -1043.1 465.081 -1033.9 469.596 -1024.3 469.596 C -1017.9 469.596 -1011.9 467.718 -1006.3 463.842 L -363.38 4.138 L -382.56 125.698 C -385.35 142.561 -373.76 158.425 -356.98 161.103 C -354.98 161.342 -353.38 161.462 -351.79 161.462 C -337 161.462 -323.81 150.593 -321.42 135.368 L -290.65 -59.199 C -289.45 -67.55 -291.45 -75.702 -296.24 -82.096 L -1050.3 455.171 Z"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }